import classNames from 'classnames'

import { Flex } from 'components/uiKit'

import s from './ItemBox.module.scss'

type ItemBoxProps = {
  children: React.ReactNode
  hasNotice?: boolean
  withoutClick?: boolean
  onClick?: () => void
}

export const ItemBox = ({ children, onClick, withoutClick = false, hasNotice = false }: ItemBoxProps) => {
  const classes = classNames(s.ItemBox, {
    [s.hasNotice]: hasNotice,
  })

  return (
    <Flex className={classes} onClick={onClick} style={{ cursor: withoutClick ? 'default' : 'pointer' }}>
      {children}
    </Flex>
  )
}
